import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const OrderViewModule = new Module({
  id: 'ORDERS:VIEW:*',
  name: 'Sales',
  label: 'Order',
  path: 'sales',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/View'))
  ),
  actions: {
    orderDetails: {
      id: 'ORDERS:VIEW:DETAILS',
      name: 'order-details',
      label: 'Order Details'
    },
    addOrderToPipeline: {
      id: 'ORDERS:VIEW:ADD-ORDER-TO-PIPELINE',
      name: 'add-order-to-pipeline',
      label: 'Add Order to Pipeline'
    },
    removeOrderFromPipeline: {
      id: 'ORDERS:VIEW:REMOVE-ORDER-FROM-PIPELINE',
      name: 'remove-order-from-pipeline',
      label: 'Remove from Pipeline'
    },
    downloadSheet: {
      id: 'ORDERS:VIEW:DOWNLOAD-SHEET',
      name: 'download-sheet',
      label: 'Download Sheet'
    },
    checkAllocatedDeviceStatus: {
      id: 'ORDERS:VIEW:CHECK-ALLOCATED-DEVICE-Status',
      name: 'check-allocated-device-Status',
      label: 'Check Device Status'
    },
    viewPdiLogs: {
      id: 'ORDERS:VIEW:PDI-LOGS',
      name: 'view-pdi-logs',
      label: 'View Pdi Logs'
    },
    startPDI: {
      id: 'ORDERS:VIEW:START-PDI',
      name: 'start-pdi',
      label: 'Start PDI'
    },
    debug: {
      id: 'ORDERS:VIEW:DEBUG-INSPECTION',
      label: 'Debug Inspection',
      name: 'debug-inspection'
    },
    startPDIAgainstOrder: {
      id: 'ORDERS:VIEW:START-PDI-ORDER',
      name: 'start-pdi-against-order',
      label: 'Start PDI'
    },
    // startMaterialAllocation: {
    //   id: 'ORDERS:VIEW:START-MATERIAL-ALLOCATION',
    //   name: 'start-material-allocation',
    //   label: 'Start Material Allocation'
    // },
    editFirmwareInOrder: {
      id: 'ORDERS:VIEW:EDIT-FIRMWARE-IN-ORDER',
      name: 'edit-firmware-in-order',
      label: 'Edit Firmware'
    },
    cancelOrder: {
      id: 'ORDERS:VIEW:CANCEL-ORDER',
      name: 'cancel-order',
      label: 'Cancel Order'
    },
    forceDispatch: {
      id: 'ORDERS:VIEW:FORCE-DISPATCH',
      name: 'force-dispatch',
      label: 'Force Dispatch'
    },
    materialPlanning: {
      id: 'ORDERS:VIEW:MATERIAL-PLANNING',
      name: 'material-planning',
      label: 'Material Planning'
    },
    copyAsTemplate: {
      id: 'ORDERS:VIEW:COPY-AS-TEMPLATE',
      name: 'copy-as-template',
      label: 'Copy as Template'
    }
  }
});

export const OrderDetailsModule = new Module({
  id: 'ORDERS:VIEW:DETAILS',
  name: 'orderDetails',
  path: 'sales/details',
  pathDef: 'sales/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/Form'))
  )
});

export const AddOrderModule = new Module({
  id: 'ORDERS:VIEW:ADD_ORDER',
  name: 'addorder',
  path: 'sales/add',
  // pathDef: 'order/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/ADD'))
  ),
  actions: {
    addOrder: {
      id: 'ORDERS:ACTION:ADD_ORDER',
      name: 'addorder',
      label: 'Add Order',
      run: () => {}
    }
  }
});

export const PDIStartModule = new Module({
  id: 'ORDERS:VIEW:PDI-START',
  name: 'pdiStart',
  path: 'sales/start-pdi',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/PDI'))
  )
});

export const DebugInspectionModule = new Module({
  id: 'ORDERS:VIEW:DEBUG-INSPECTION',
  name: 'debugInspection',
  path: 'sales/debug-inspection',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/DebugInspection'))
  ),
  actions: {
    viewReport: {
      id: 'ORDERS:VIEW:REPORT',
      name: 'view-report',
      label: 'View Report'
    }
  }
});

export const MaterialPlanningModule = new Module({
  id: 'ORDERS:VIEW:MATERIAL-PLANNING',
  name: 'materialPlanning',
  path: 'sales/material-planning',
  pathDef: 'sales/material-planning/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/MaterialPlanning'))
  )
});

const OrderModules = [
  OrderViewModule,
  PDIStartModule,
  OrderDetailsModule,
  DebugInspectionModule,
  AddOrderModule,
  MaterialPlanningModule
];

export default new ModuleBundle('Order', OrderModules);
